import { Analysis, InputValueProps, Sample } from "types";
import { SIGNATURE_MAX_LENGTH } from 'constants/validation';
import { isLabValidForAnalysis } from "functions/isLabValidForAnalysis";
import { isM3StatusValidForSample} from "functions/isM3StatusValidForSample";

export const isApproveDisabled = ({
  sample,
  newExtraAnalyzes,
  inputValue,
  text,
  oldText,
  isSaving,
  enableConditions,
  disableConditions,
}: {
  sample: Sample | undefined;
  newExtraAnalyzes: Analysis[];
  inputValue: InputValueProps;
  text: string;
  oldText: string;
  isSaving: boolean;
  enableConditions?: boolean[];
  disableConditions?: boolean[];
}): boolean => {
  let isDisabled = true;
  // Rules to enable button
  if (newExtraAnalyzes.length > 0 || text !== oldText) {
    isDisabled = false;
  }
  enableConditions?.forEach((condition) => {
    if (condition === true) {
      isDisabled = false;
    }
  });

  // Rules to disable button
  const invalidLabForAnalysis = !isLabValidForAnalysis(sample?.lab);
  const invalidM3StatusForSample = !isM3StatusValidForSample(
    sample?.m3StatusAnmodan,
  );

  if (invalidLabForAnalysis) {
    isDisabled = true;
  }
  if (invalidM3StatusForSample) {
    isDisabled = true;
  }
  if (!inputValue.signature || !inputValue.sampleId) {
    isDisabled = true;
  }

  if (inputValue.signature.length > SIGNATURE_MAX_LENGTH) {
    isDisabled = true;
  }
  if (sample?.completed) {
    isDisabled = true;
  }
  if (isSaving) {
    isDisabled = true;
  }
  disableConditions?.forEach((condition) => {
    if (condition === true) {
      isDisabled = true;
    }
  });
  return isDisabled;
};
